module.exports = __webpack_public_path__ + "assets/svg/Icons/32/announcement-gray-716e34.svg";